(() => {
  'use strict';
  const config = document.querySelector('#CommerceConfig');
  const drawer = document.querySelector('#CartDrawer');
  if (!config || !drawer || !window.BeerClubCommerce || !drawer.showModal) return;
  const api = window.BeerClubCommerce;
  const settings = JSON.parse(config.textContent);
  const client = api.createClient(settings);
  const enabled = () => drawer.dataset.enabled !== 'false';
  const content = () => drawer.querySelector('[data-cart-content]');
  let cartPageChanged = false;
  let busy = false, previousFocus, rateController, scrollLock, viewportState, mutationFocusId = '';
  let address = { zip: '', state: undefined }, selectedRate = null, discountMessage = '';
  const status = text => { const node = drawer.querySelector('[data-cart-status]'); if (node) node.textContent = text; };
  function renderedCodes() {
    let codes = [];
    try { codes = JSON.parse(content()?.dataset.discountCodes || '[]'); } catch { /* Read the server-rendered code chips below. */ }
    return api.discountCodes([...codes, ...drawer.querySelectorAll('[data-cart-discount-remove]:not([data-pending])')].map(item => typeof item === 'string' ? item : item.dataset.code));
  }
  let activeCodes = renderedCodes();
  let confirmedCodes = new Set();
  function summary() {
    [content(), ...document.querySelectorAll('[data-cart-page-summary]')].forEach(updateSummary);
  }
  function updateSummary(node) {
    if (!node || node.dataset.total === undefined) return;
    const currentSettings = JSON.parse(config.textContent);
    const pixEnabled = currentSettings.pixEnabled === true || (currentSettings.pixEnabled === undefined && node.dataset.pixEnabled === 'true');
    const pixPercent = pixEnabled ? Number(currentSettings.pixPercent ?? node.dataset.pixPercent) || 0 : 0;
    node.querySelectorAll('[data-cart-pix-row]').forEach(target => { target.hidden = !pixEnabled; });
    node.querySelectorAll('[data-cart-regular-row]').forEach(target => { target.hidden = pixEnabled; });
    node.querySelectorAll('[data-cart-pix-saving]').forEach(target => {
      target.hidden = pixPercent <= 0;
      target.textContent = pixPercent > 0 ? (Number(node.dataset.pixApplied) > 0 ? 'Desconto PIX já incluído no valor à vista.' : String(pixPercent).replace('.', ',') + '% de desconto no PIX.') + (node.dataset.requiresShipping !== 'false' ? ' Desconto válido somente nos produtos.' : '') : '';
    });
    let totals;
    try { totals = api.cartSummary({ total: node.dataset.total, currency: node.dataset.currency, requiresShipping: node.dataset.requiresShipping !== 'false', pixPercent, pixApplied: node.dataset.pixApplied || 0 }, selectedRate); }
    catch { return; }
    const money = cents => api.rateMoney(cents / 100, node.dataset.currency || 'BRL');
    const set = (selector, text) => node.querySelectorAll(selector).forEach(target => { target.textContent = text; });
    set('[data-cart-pix-total]', money(totals.pix));
    set('[data-cart-card-total]', money(totals.card));
    set('[data-cart-installment]', money(totals.installment));
    set('[data-cart-total-label]', totals.quoted ? 'Total estimado' : totals.requiresShipping ? 'Subtotal' : 'Total');
    set('[data-cart-shipping-value]', totals.shipping === null ? 'A calcular' : totals.requiresShipping ? totals.shipping === 0 ? 'Grátis' : money(totals.shipping) : 'Não necessário');
    node.dataset.shippingQuoted = String(totals.quoted);
  }
  function discountState() {
    const output = drawer.querySelector('[data-cart-discount-status]');
    if (output) output.textContent = discountMessage;
    const visibleCodes = api.discountCodes([...renderedCodes(), ...activeCodes.filter(code => confirmedCodes.has(code.toLocaleLowerCase()))]);
    const applied = drawer.querySelector('[data-cart-applied-discounts]');
    if (applied) {
      applied.hidden = !visibleCodes.length && !(Number(applied.dataset.discountTotal) > 0);
      const chips = applied.querySelector('[data-cart-applied-codes]');
      if (chips) {
        chips.replaceChildren();
        visibleCodes.forEach(code => {
          const chip = document.createElement('span'); chip.className = 'bc-cart-discount-code';
          const label = document.createElement('span'); label.textContent = code;
          const button = document.createElement('button'); button.type = 'button'; button.dataset.cartDiscountRemove = ''; button.dataset.code = code; button.dataset.pending = '';
          button.setAttribute('aria-label', 'Remover cupom ' + code); button.textContent = '×';
          chip.append(label, button); chips.append(chip);
        });
      }
    }
    const list = drawer.querySelector('[data-cart-discount-list]');
    if (!list) return;
    list.querySelectorAll('[data-pending-discount]').forEach(node => node.remove());
    const confirmed = renderedCodes().map(code => code.toLocaleLowerCase());
    activeCodes.filter(code => !confirmed.includes(code.toLocaleLowerCase())).forEach(code => {
      const chip = document.createElement('span'); chip.className = 'bc-cart-discount-code'; chip.dataset.pendingDiscount = '';
      const label = document.createElement('span'); label.textContent = code + (confirmedCodes.has(code.toLocaleLowerCase()) ? '' : ' · a confirmar');
      const button = document.createElement('button'); button.type = 'button'; button.dataset.cartDiscountRemove = ''; button.dataset.code = code; button.dataset.pending = '';
      button.setAttribute('aria-label', 'Remover cupom ' + code); button.textContent = '×';
      chip.append(label, button); list.append(chip);
    });
    list.hidden = !list.childElementCount;
  }
  function lockPage() {
    if (scrollLock) return;
    const body = document.body, html = document.documentElement;
    const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
    scrollLock = { x: window.scrollX, y: window.scrollY, overflow: html.style.getPropertyValue('overflow'), body: properties.map(property => [property, body.style.getPropertyValue(property)]) };
    const gap = Math.max(0, window.innerWidth - html.clientWidth);
    const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
    html.style.setProperty('overflow', 'hidden');
    body.style.setProperty('position', 'fixed'); body.style.setProperty('top', -scrollLock.y + 'px'); body.style.setProperty('left', -scrollLock.x + 'px');
    body.style.setProperty('width', '100%'); body.style.setProperty('overflow', 'hidden');
    if (gap) body.style.setProperty('padding-right', padding + gap + 'px');
  }
  function unlockPage() {
    if (!scrollLock) return;
    const saved = scrollLock; scrollLock = null;
    saved.body.forEach(([property, value]) => value ? document.body.style.setProperty(property, value) : document.body.style.removeProperty(property));
    if (saved.overflow) document.documentElement.style.setProperty('overflow', saved.overflow); else document.documentElement.style.removeProperty('overflow');
    window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
  }
  function syncViewport() {
    const viewport = viewportState?.viewport;
    if (!drawer.open || !viewport || !Number.isFinite(viewport.height) || viewport.height <= 0) return;
    drawer.style.setProperty('--bc-cart-viewport-height', viewport.height + 'px');
    drawer.style.setProperty('--bc-cart-viewport-top', Math.max(0, Number(viewport.offsetTop) || 0) + 'px');
  }
  function observeViewport() {
    if (viewportState || !window.visualViewport) return;
    const viewport = window.visualViewport;
    viewportState = { viewport, properties: ['--bc-cart-viewport-height', '--bc-cart-viewport-top'].map(name => [name, drawer.style.getPropertyValue(name), drawer.style.getPropertyPriority?.(name) || '']) };
    viewport.addEventListener('resize', syncViewport, { passive: true });
    viewport.addEventListener('scroll', syncViewport, { passive: true });
    syncViewport();
  }
  function releaseViewport() {
    if (!viewportState) return;
    const saved = viewportState; viewportState = null;
    saved.viewport.removeEventListener('resize', syncViewport);
    saved.viewport.removeEventListener('scroll', syncViewport);
    saved.properties.forEach(([name, value, priority]) => value ? drawer.style.setProperty(name, value, priority) : drawer.style.removeProperty(name));
  }
  function open() {
    if (!enabled()) return;
    if (!drawer.open) { previousFocus = document.activeElement; lockPage(); drawer.showModal(); observeViewport(); }
  }
  function invalidateShipping() {
    rateController?.abort(); rateController = null; selectedRate = null;
    document.querySelectorAll('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-summary]').forEach(node => { node.textContent = 'Calcular'; });
    document.querySelectorAll('.shipping-box:not(.shipping-box--product) [data-shipping-benefit]').forEach(node => { node.replaceChildren(); node.hidden = true; });
    document.querySelectorAll('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-results]').forEach(node => { node.textContent = ''; });
    document.querySelectorAll('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-calculate]').forEach(node => { if (!busy) node.disabled = false; });
    summary();
  }
  function restoreAddress() {
    document.querySelectorAll('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-zip]').forEach(node => { node.value = address.zip; });
  }
  function render(html) {
    if (typeof html !== 'string') throw new Error('Não foi possível atualizar o carrinho. Feche e abra novamente.');
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
    if (!parsed) throw new Error('Não foi possível atualizar o carrinho. Feche e abra novamente.');
    const activeId = drawer.contains(document.activeElement) ? document.activeElement.id : '';
    const codeInput = drawer.querySelector('[data-cart-discount-input]')?.value || '';
    const tools = [...drawer.querySelectorAll('[data-cart-tool][open]')].map(tool => tool.id);
    const scrollTop = drawer.querySelector('.bc-cart-items')?.scrollTop || 0;
    content().replaceWith(parsed);
    document.querySelectorAll('[data-cart-page-summary]').forEach(node => {
      ['total', 'pixApplied', 'pixEnabled', 'pixPercent', 'currency', 'requiresShipping'].forEach(key => { node.dataset[key] = parsed.dataset[key] || (key === 'pixApplied' ? '0' : ''); });
    });
    confirmedCodes.clear();
    discountMessage = '';
    drawer.querySelector('.bc-cart-items')?.scrollTo({ top: scrollTop });
    tools.forEach(id => { const tool = document.getElementById(id); if (tool && drawer.contains(tool)) tool.open = true; });
    const input = drawer.querySelector('[data-cart-discount-input]'); if (input) input.value = codeInput;
    activeCodes = api.discountCodes([...activeCodes, ...renderedCodes()]);
    document.querySelectorAll('.cart-count').forEach(node => { node.textContent = parsed.dataset.count; });
    document.querySelectorAll('.cart-open').forEach(node => { node.setAttribute('aria-label', 'Sacola com ' + parsed.dataset.count + ' itens'); });
    restoreAddress(); summary(); discountState();
    if (busy) lock(true);
    if (drawer.open) (activeId && document.getElementById(activeId) || drawer.querySelector('[data-cart-close]'))?.focus({ preventScroll: true });
  }
  async function refresh() {
    const data = await client.section(); render(data['cart-drawer']);
  }
  function lock(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    // Keep native disabled stock controls disabled when restoring the UI.
    document.querySelectorAll('.js-product-form button[type=submit], [data-bundle-add], #CartDrawer button:not([data-cart-close]), #CartDrawer input, #CartDrawer select').forEach(node => {
      if (value && !node.disabled) { node.dataset.cartLocked = ''; node.disabled = true; }
      else if (!value && node.hasAttribute('data-cart-locked')) { node.disabled = false; delete node.dataset.cartLocked; }
    });
  }
  async function mutate(action, message, quiet = false) {
    if (busy) return false;
    mutationFocusId = drawer.contains(document.activeElement) ? document.activeElement.id : '';
    invalidateShipping();
    if (document.body.classList.contains('template-cart')) cartPageChanged = true;
    lock(true); status(quiet ? '' : 'Atualizando sua sacola…');
    try {
      const data = await action();
      try { render(data.sections?.['cart-drawer']); } catch { await refresh(); }
      const announcement = typeof message === 'function' ? message(data) : message;
      status(quiet ? '' : announcement);
      return true;
    } catch (error) {
      // Never retry an uncertain POST: it may already have changed the cart.
      try { await refresh(); } catch { /* Closing and reopening starts a fresh cart read. */ }
      const announcement = error.message + ' Confira os itens antes de tentar novamente.';
      if (quiet) { discountMessage = announcement; discountState(); } else status(announcement);
      return false;
    } finally {
      lock(false); document.dispatchEvent(new CustomEvent('beerclub:cart-updated'));
      if (drawer.open && mutationFocusId) document.getElementById(mutationFocusId)?.focus({ preventScroll: true });
      mutationFocusId = '';
      if (address.zip && drawer.open) drawer.querySelector('[data-shipping-calculate]')?.click();
    }
  }
  async function applyDiscount(code, remove = false) {
    if (busy) return;
    const codes = remove ? activeCodes.filter(item => item.toLocaleLowerCase() !== code.toLocaleLowerCase()) : api.discountCodes([...activeCodes, code]);
    discountMessage = 'Conferindo o cupom…'; discountState();
    await mutate(() => client.applyDiscount(codes), data => {
      const result = api.discountResult(data, code, renderedCodes());
      if (result === 'applied' && !remove) confirmedCodes.add(code.toLocaleLowerCase());
      activeCodes = remove ? api.discountCodes([...codes, ...renderedCodes()]) : result === 'not_applicable' ? codes.filter(item => item.toLocaleLowerCase() !== code.toLocaleLowerCase()) : codes;
      discountMessage = remove ? result === 'applied' ? 'Não foi possível confirmar a remoção. Confira no checkout.' : 'Cupom removido.' : result === 'applied' ? 'Cupom aplicado à sua sacola.' : result === 'not_applicable' ? 'Este cupom não se aplica aos itens da sacola. Confira as condições.' : 'Código enviado. Confirme o desconto no checkout.';
      if (!remove && result !== 'not_applicable') { const input = drawer.querySelector('[data-cart-discount-input]'); if (input) input.value = ''; }
      discountState();
      return discountMessage;
    }, true);
    if (discountMessage === 'Conferindo o cupom…') { discountMessage = 'Não foi possível confirmar o cupom. Confira sua sacola antes de tentar novamente.'; discountState(); }
  }
  drawer.addEventListener('close', () => { releaseViewport(); unlockPage(); if (cartPageChanged) window.location.reload(); else previousFocus?.focus({ preventScroll: true }); });
  drawer.addEventListener('click', event => {
    if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) drawer.close(); }
    const closeTool = event.target.closest('[data-cart-tool-close]');
    if (closeTool) { const tool = closeTool.closest('[data-cart-tool]'); tool.open = false; tool.querySelector('summary')?.focus({ preventScroll: true }); }
  });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const tool = drawer.querySelector('[data-cart-tool][open]');
    if (tool) { event.preventDefault(); tool.open = false; tool.querySelector('summary')?.focus({ preventScroll: true }); }
  });
  drawer.addEventListener('toggle', event => {
    const tool = event.target;
    if (!tool.matches('[data-cart-tool]') || !tool.open) return;
    drawer.querySelectorAll('[data-cart-tool][open]').forEach(other => { if (other !== tool) other.open = false; });
  }, true);
  drawer.addEventListener('beerclub:shipping-selected', event => {
    selectedRate = { ...event.detail.rate, currency: event.detail.currency }; summary();
    const tool = event.target.closest('[data-cart-tool]');
    if (tool?.open) { const focused = tool.contains(document.activeElement); tool.open = false; if (focused) tool.querySelector('summary')?.focus({ preventScroll: true }); }
  });
  document.addEventListener('beerclub:shipping-selected', event => {
    if (event.target.closest('.cart-page')) {
      selectedRate = { ...event.detail.rate, currency: event.detail.currency }; summary();
    }
  });
  // Browsers can restore the pre-checkout DOM from the back/forward cache.
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
  document.addEventListener('submit', async event => {
    if (event.target.matches('#DrawerCheckout')) { if (busy) event.preventDefault(); return; }
    if (event.target.matches('[data-cart-discount-form]')) {
      event.preventDefault();
      const input = event.target.querySelector('[data-cart-discount-input]');
      if (!busy && input.reportValidity() && input.value.trim()) await applyDiscount(input.value.trim());
      return;
    }
    if (!enabled() || !event.target.matches('.js-product-form')) return;
    event.preventDefault();
    if (busy) return;
    const form = event.target;
    if (form.querySelector('button[type="submit"][name="add"]')?.disabled || !form.reportValidity()) return;
    const formData = new FormData(form); open();
    await mutate(() => client.add(formData), 'Adicionado à sua sacola.');
  });
  document.addEventListener('click', async event => {
    const discountRemove = event.target.closest('[data-cart-discount-remove]');
    if (discountRemove) { await applyDiscount(discountRemove.dataset.code, true); return; }
    const bundle = event.target.closest('[data-bundle-add]');
    if (bundle) {
      if (busy) return;
      const section = bundle.closest('[data-bundle]');
      const form = document.querySelector('.native-product-form');
      if (!form || !form.reportValidity()) return;
      const extras = [...section.querySelectorAll('[data-bundle-option]:checked')];
      if (!extras.length) return;
      const formData = new FormData(form);
      const primary = { id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) };
      if (formData.get('selling_plan')) primary.selling_plan = formData.get('selling_plan');
      const properties = {};
      for (const [key, value] of formData.entries()) if (key.startsWith('properties[') && key.endsWith(']') && typeof value === 'string') properties[key.slice(11, -1)] = value;
      if (Object.keys(properties).length) primary.properties = properties;
      const items = [primary, ...extras.map(input => ({ id: input.value, quantity: Number(input.dataset.quantity) }))];
      open();
      const success = await mutate(() => client.addItems(items), 'Sua seleção foi adicionada à sacola.');
      if (success && !enabled()) window.location.assign(settings.cart);
      return;
    }
    const close = event.target.closest('[data-cart-close]');
    if (close) { drawer.close(); return; }
    const link = event.target.closest('.cart-open, [data-open-shipping]');
    if (enabled() && link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); open();
      if (!busy) {
        invalidateShipping(); lock(true); status('Conferindo sua sacola…');
        try { await refresh(); status(''); } catch (error) { status(error.message); } finally { lock(false); if (address.zip) drawer.querySelector('[data-shipping-calculate]')?.click(); }
      }
      if (link.hasAttribute('data-open-shipping')) {
        const estimator = drawer.querySelector('[data-shipping-estimator]');
        if (estimator) { estimator.open = true; estimator.querySelector('input').focus(); }
        else status('Consulte a entrega no checkout.');
      }
      return;
    }
    const update = event.target.closest('[data-cart-update], [data-cart-remove]');
    if (update) {
      if (busy) return;
      const line = update.closest('[data-line-key]');
      const input = line.querySelector('[data-cart-quantity]');
      const remove = update.hasAttribute('data-cart-remove');
      if (!remove && (!input.reportValidity() || !Number.isInteger(Number(input.value)))) return;
      await mutate(() => client.change(line.dataset.lineKey, remove ? 0 : Number(input.value)), remove ? 'Item removido.' : 'Quantidade atualizada.');
      return;
    }
    const calculate = event.target.closest('[data-shipping-calculate]');
    if (!calculate || busy) return;
    const widget = calculate.closest('[data-shipping-estimator]');
    const output = widget.querySelector('[data-shipping-results]');
    address = { zip: widget.querySelector('[data-shipping-zip]').value.trim(), state: undefined };
    invalidateShipping();
    try { api.address(address.zip, address.state); } catch (error) { output.textContent = error.message; widget.querySelector('[data-shipping-zip]').focus(); return; }
    const controller = new AbortController(); rateController = controller;
    calculate.disabled = true; output.textContent = 'Consultando as transportadoras…';
    try {
      const rates = await client.shipping(address.zip, address.state, controller.signal);
      if (controller.signal.aborted || rateController !== controller) return;
      output.replaceChildren();
      if (!rates.length) { output.textContent = 'Nenhuma opção disponível para este endereço e estes itens. Confira o CEP ou fale com o atendimento.'; return; }
      const currency = content().dataset.currency || 'BRL';
      window.BeerClubShippingView.render(widget, rates, currency);
    } catch (error) { if (error.name !== 'AbortError' && rateController === controller) output.textContent = error.message; }
    finally { if (rateController === controller) { calculate.disabled = false; rateController = null; } }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-zip]')) {
      invalidateShipping(); address.zip = '';
      const digits = event.target.value.replace(/\D/g, '').slice(0, 8); event.target.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    }
    if (event.target.matches('#CartForm input[name="updates[]"]')) {
      invalidateShipping();
      document.querySelectorAll('.cart-page [data-shipping-results]').forEach(node => { node.textContent = 'Atualize a sacola antes de consultar o frete para as novas quantidades.'; });
      document.querySelectorAll('.cart-page [data-shipping-calculate]').forEach(node => { node.disabled = true; });
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]') && !busy && event.target.reportValidity()) event.target.closest('[data-line-key]').querySelector('[data-cart-update]').click();
  });
  document.addEventListener('click', event => {
    const menu = event.target.closest('.native-menu'); if (menu && event.target.closest('a')) menu.open = false;
    document.querySelectorAll('.nav-dropdown[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (!event.defaultPrevented && event.key === 'Enter' && event.target.matches('[data-shipping-estimator]:not([data-shipping-product]) [data-shipping-zip]')) {
      event.preventDefault();
      if (!busy) event.target.closest('[data-shipping-estimator]')?.querySelector('[data-shipping-calculate]')?.click();
      return;
    }
    if (event.key !== 'Escape' || drawer.open) return;
    document.querySelectorAll('.native-menu[open], .nav-dropdown[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
  });
  summary(); discountState();
})();
